import React, { createContext, useState } from "react"
import MyCard from "../../../../utils/MyCard"
import CompteInfoPersoPreview from "./preview/CompteInfoPersoPreview"
import { CompteInfoPersoEdit } from "./edit/CompteInfoPersoEdit"
import clsx from "clsx"
import { TUTORIAL_TARGET_PROFIL_EDIT_INFO_PERSO } from "../../../../components/tutorial/targets/profile"

const CompteInfoPersoContext = createContext<ICompteInfoPersoContextPropsModel>({} as ICompteInfoPersoContextPropsModel)

function CompteInfoPerso() {
     const [mode, setMode] = useState<"PREVIEW" | "EDITION">("PREVIEW")

     return (
          <CompteInfoPersoContext.Provider value={{ toggleToPreviewMode: () => setMode("PREVIEW") }}>
               <MyCard>
                    <MyCard.Header
                         rightSideContent={
                              <div onClick={() => setMode(prev => (prev === "PREVIEW" ? "EDITION" : "PREVIEW"))} className={"cursor-pointer"}>
                                   {mode === "EDITION" ? (
                                        <span className={"fas fa-eye fs-1 text-hover-primary"} />
                                   ) : (
                                        <button
                                             type={"button"}
                                             className={clsx("btn btn-warning btn-sm d-flex align-items-center px-3 py-2", TUTORIAL_TARGET_PROFIL_EDIT_INFO_PERSO)}
                                        >
                                             <span className={"d-md-inline d-none me-1"}>Modifier</span> <span className={"fas fa-edit"} />
                                        </button>
                                   )}
                              </div>
                         }
                    >
                         Mes informations personnelles
                    </MyCard.Header>
                    <MyCard.Body>
                         <>{mode === "PREVIEW" ? <CompteInfoPersoPreview /> : <CompteInfoPersoEdit />}</>
                    </MyCard.Body>
               </MyCard>
          </CompteInfoPersoContext.Provider>
     )
}

interface ICompteInfoPersoContextPropsModel {
     toggleToPreviewMode: () => void
}

export { CompteInfoPerso, CompteInfoPersoContext }
